import styled from 'styled-components';

const SearchIconWrapper = styled.button`
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  background: transparent;
  border-radius: 0 5px 5px 0;
  position: absolute;
  right: 0;
  top: 5px;
  cursor: pointer;
`;

const NotificationActionButton = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.secondary500};
  font: inherit;
  font-size: ${(p) => p.theme.fontSizes.base};
  text-decoration: underline;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const SearchBar = styled.form`
  display: flex;
  width: 100%;
  max-width: 600px;
  padding-bottom: 20px;
  position: relative;
`;

const ContentWrapper = styled.div`
  height: 185px;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: ${(p) => p.theme.fontSizes.md};
  line-height: 23px;
  color: ${(p) => p.theme.colors.gray300};
`;

const CardWrapper = styled.div`
  ${(p) => p.theme.outsideShadowW02};
  padding: 25px;
  margin-right: 15px;
  margin-bottom: 15px;
  width: 100%;
  max-width: 1200px;
`;

const ModalForm = styled.form`
  position: absolute;
  top: 40%;
  left: calc(50% - 205px);
  width: 510px;
  background-color: #fff;
  padding: 25px;
  border-radius: 40px 40px 40px 0px;
`;

const ModalTitle = styled.div`
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
  color: ${(p) => p.theme.colors.gray500};
  margin-bottom: 15px;
  text-align: center;
`;

const ModalNotice = styled.div`
  font-size: ${(p) => p.theme.fontSizes.base};
  color: ${(p) => p.theme.colors.red};
  margin-bottom: 15px;
`;

export {
  CardWrapper,
  ContentWrapper,
  SearchIconWrapper,
  SearchBar,
  ModalForm,
  ModalTitle,
  ModalNotice,
  NotificationActionButton,
};
